import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_videos_channel.breadcrumb.videos_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_videos_channel.breadcrumb.videos_label2'),
  },
];
